import React from 'react';
import { NavLink } from 'react-router-dom';
import { getProducts } from '../../services/api';

const defaultProducts = [
    {
        id: 'acp-front-elevation',
        slug: 'acp-front-elevation',
        count: '01',
        icon: 'fa fa-building',
        title: 'ACP Front Elevation',
        shortDesc: 'High-grade, weather-resistant ACP panel front elevation for modern building exteriors and stylish elevations.',
    },
    {
        id: 'facade-glazing',
        slug: 'facade-glazing',
        count: '02',
        icon: 'fa fa-window-maximize',
        title: 'Facade Glazing',
        shortDesc: 'Modern facade glazing systems designed for a clean architectural finish, strong performance, and long-lasting durability.',
    },
    {
        id: 'toughened-glass',
        slug: 'toughened-glass',
        count: '03',
        icon: 'fa fa-shield',
        title: 'Toughened Glass',
        shortDesc: 'Strong and durable Toughened Glass designed for enhanced safety, impact resistance, and reliable performance.',
    },
];

class ProductsSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            products: defaultProducts
        };
    }

    async componentDidMount() {
        try {
            const apiProducts = await getProducts({}, defaultProducts);
            if (apiProducts && apiProducts.length > 0) {
                const limit = this.props.limit;
                const finalProducts = limit ? apiProducts.slice(0, limit) : apiProducts;
                this.setState({ products: finalProducts });
            }
        } catch (e) {
            console.warn('[ProductsSection] API fetch fallback to default products.');
        }
    }

    render() {
        const { products } = this.state;

        return (
            <div className="section-full mobile-page-padding bg-gray p-t80 p-b50 overflow-hide">
                <div className="container">
                    <div className="large-title-block text-center wow fadeInUp" data-wow-duration="1s">
                        <div className="section-head text-center">
                            <div className="sx-separator-outer separator-center">
                                <div className="sx-separator bg-white">
                                    <h3 className="sep-line-one">Products</h3>
                                </div>
                            </div>
                            {/* <p style={{ color: '#666', fontSize: '15px', maxWidth: '650px', margin: '15px auto 40px auto', textAlign: 'center' }}>
                                Delivering quality architectural ACP Front Elevation, Facade Glazing, Toughened Glass, and skilled trained labour in Coimbatore.
                            </p> */}
                        </div>
                    </div>
                    <div className="section-content">
                        <div className="row">
                            {products.map((item, index) => (
                                <div className="col-lg-4 col-md-6 col-sm-12 m-b30 wow fadeInUp" data-wow-duration="1s" data-wow-delay={`${(index % 3) * 0.15 + 0.1}s`} key={index}>
                                    <div className="bg-white bdr-gray-light bdr-solid bdr-1" style={{
                                        borderRadius: '12px',
                                        overflow: 'hidden',
                                        height: '100%',
                                        boxShadow: '0 6px 20px rgba(0,0,0,0.06)',
                                        borderTop: '4px solid #f03a02',
                                        transition: 'transform 0.35s ease, box-shadow 0.35s ease, border-color 0.35s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-8px)';
                                        e.currentTarget.style.boxShadow = '0 14px 35px rgba(240, 58, 2, 0.14)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.06)';
                                    }}>
                                        <div className="p-a30" style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', position: 'relative' }}>
                                            <div>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '18px' }}>
                                                    <div style={{
                                                        width: '48px',
                                                        height: '48px',
                                                        borderRadius: '10px',
                                                        backgroundColor: 'rgba(240, 58, 2, 0.08)',
                                                        color: '#f03a02',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '22px'
                                                    }}>
                                                        <i className={item.icon || 'fa fa-cube'} />
                                                    </div>
                                                    <span style={{ fontSize: '24px', fontWeight: '800', color: '#e0e0e0' }}>{item.count || `0${index + 1}`}</span>
                                                </div>
                                                <h4 style={{ fontWeight: '800', fontSize: '19px', marginBottom: '12px', color: '#111111' }}>
                                                    {item.title}
                                                </h4>
                                                <p style={{ color: '#666666', fontSize: '14px', lineHeight: '1.6', marginBottom: '20px' }}>
                                                    {item.shortDesc || item.description}
                                                </p>
                                            </div>
                                            <div>
                                                {(() => {
                                                    const targetSlug = (item.slug && item.slug.trim()) ? item.slug.trim() : (item.id || 'acp-front-elevation');
                                                    return (
                                                        <NavLink
                                                            to={`/product/${encodeURIComponent(targetSlug)}`}
                                                            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                                            style={{
                                                                color: '#f03a02',
                                                                fontWeight: '700',
                                                                fontSize: '14px',
                                                                textDecoration: 'none',
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                gap: '6px'
                                                            }}
                                                        >
                                                            <span>View Details</span>
                                                            <i className="fa fa-arrow-right" style={{ fontSize: '12px' }} />
                                                        </NavLink>
                                                    );
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProductsSection;
